import { supabase } from '../lib/supabase';

const toCamelCase = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj?.map(toCamelCase);
  return Object.keys(obj)?.reduce((acc, key) => {
    const camelKey = key?.replace(/_([a-z])/g, (_, letter) => letter?.toUpperCase());
    acc[camelKey] = toCamelCase(obj?.[key]);
    return acc;
  }, {});
};

export const warrantyService = {
  async getByVehicle(vehicleId) {
    try {
      const { data, error } = await supabase?.from('warranties')?.select('*')?.eq('vehicle_id', vehicleId)?.order('created_at', { ascending: false });
      if (error) { console.error('[warrantyService]', error); return []; }
      return (data || [])?.map(toCamelCase);
    } catch (err) { console.error('[warrantyService] Failed getByVehicle:', err); return []; }
  },
  async getByClient(clientId) {
    try {
      const { data, error } = await supabase?.from('warranties')?.select('*, vehicle:vehicles(marca, modelo, year, placas)')?.eq('client_id', clientId)?.order('created_at', { ascending: false });
      if (error) { console.error('[warrantyService]', error); return []; }
      return (data || [])?.map(toCamelCase);
    } catch (err) { console.error('[warrantyService] Failed getByClient:', err); return []; }
  },
  async getByWorkOrder(workOrderId) {
    try {
      const { data, error } = await supabase?.from('warranties')?.select('*')?.eq('work_order_id', workOrderId)?.order('created_at', { ascending: false });
      if (error) { console.error('[warrantyService]', error); return []; }
      return (data || [])?.map(toCamelCase);
    } catch (err) { console.error('[warrantyService] Failed getByWorkOrder:', err); return []; }
  },
  async create(warrantyData) {
    try {
      const { data, error } = await supabase?.from('warranties')?.insert({
        company_id: warrantyData?.companyId,
        client_id: warrantyData?.clientId,
        vehicle_id: warrantyData?.vehicleId,
        work_order_id: warrantyData?.workOrderId,
        warranty_type: warrantyData?.warrantyType || 'servicio',
        start_date: warrantyData?.startDate,
        end_date: warrantyData?.endDate,
        notes: warrantyData?.notes || null,
        status: 'activa'
      })?.select()?.single();
      if (error) throw error;
      return toCamelCase(data);
    } catch (err) { console.error('[warrantyService] Failed create:', err); throw err; }
  },
  async update(id, updates) {
    try {
      const { data, error } = await supabase?.from('warranties')?.update(updates)?.eq('id', id)?.select()?.single();
      if (error) throw error;
      return toCamelCase(data);
    } catch (err) { console.error('[warrantyService] Failed update:', err); throw err; }
  }
};
